/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ThemeType } from "@microsoft/shifts-ui-core";
import { mutatorAction } from "satcheljs";

import { SharedStateStore } from "../store/SharedStateStore";

/**
 * Set the theme in the shared state store.
 */
export const setTheme = mutatorAction("setTheme", (themeType: ThemeType) => {
    SharedStateStore().theme = themeType;
});
